exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".left-side-menu {\n  display: flex;\n  min-height: calc(92vh - 104px);\n  flex-direction: column;\n  justify-content: space-between;\n  background-color: #fff;\n  border-right: 1px solid #dbdbdb;\n  border-bottom: 1px solid #dbdbdb;\n}\n.left-side-menu__panel {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-left: 16px;\n  font-size: 32px;\n  border-top: 1px solid #dbdbdb;\n  border-bottom: 1px solid #dbdbdb;\n  height: 9vh;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/components/LeftSideMenu/LeftSideMenu.less
// module id = 882
// module chunks = 0